export default "__VITE_ASSET__Boq3_qBl__"